module.exports = __webpack_public_path__ + "img/logo.a7b39c2c.svg";